import React, { useState, useEffect } from 'react';
import {Button, Modal} from 'react-bootstrap';
import {
    cancelCajaRecordByRecordId
  } from '../../../../../../../../../../crud/management_api/caja_session_records';
import {toast} from 'react-toastify';
import { CajaRecordType } from '../../../../types';
import MiniLoadingSpinner from '../../../../../../../../../../components/Spinners/MiniLoadingSpinner';


interface CancelModalProps {
    show: boolean;
    handleClose: () => void;
    record: any;
    currentData: any;
    setCurrentData: any;
}

const CancelRecordModal:React.FC<CancelModalProps> = ({
    show,
    handleClose,
    record,
    currentData,
    setCurrentData
}) => {
    const [loading, setLoading] = useState(false);

    const handleCancelRecord = () => {
        setLoading(true);
        cancelCajaRecordByRecordId(record.caja_session_record_id)
          .then((res) => {
            if (res) {
              toast.success('Arqueo cancelado');
              const updatedData = currentData.map((record:CajaRecordType) => {
                if (record.caja_session_record_id === (res as any).data.caja_session_record_id) {
                  return (res as any).data;
                }
                return record;
              });
              setCurrentData(updatedData);
              handleClose();
            }
          })
          .catch((error) => {
            console.error('Error canceling record: ', error);
            toast.error('Error cancelando arqueo');
          }).finally(() => setLoading(false));
      }

    return (
        <Modal show={show}>
            <Modal.Header>
                <Modal.Title>Cancelar registro</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {loading && <MiniLoadingSpinner left='40%'/>}
                {!loading && <>
                <p>¿Estás seguro que deseas cancelar este arqueo?</p>
                <p>
                    Esto no se puede revertir, y en caso de que este arqueo corresponda a la sesión actual, 
                    tendrás que volver a hacerlo para poder finalizar la sesión.
                </p>
                </>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className='form-button-cancel' onClick={handleClose}>Volver</Button>
                <Button variant="danger" className='form-button-create' onClick={handleCancelRecord}>Cancelar registro</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CancelRecordModal;